import { useRef, useState, useEffect } from "react";

import {
  faCheck,
  faTimes,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";


const AwbAllotment = () => {

  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { auth } = useAuth();
  const [user, setUser] = useState("");

  // const [role, setRole] = useState("");
  const [AwbFrom, setAwbFrom] = useState("");
  const [Franchise_Name, setFranchise_Name] = useState("");
  const [AwbTo, setAwbTo] = useState("");
  const [userFocus, setUserFocus] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [franchiseCode, setFranchiseCode] = useState('');
  const [franchiseDbId, setFranchiseDbId] = useState('');
  const [franchiseList, setFranchiseList] = useState([]);
  const [filteredFranchises, setFilteredFranchises] = useState([]);

  const LIST_FRANCHISE_URL = "api/list-franchises";
  const AWB_ALLOTMENT_URL = "api/admin/awballotment";
  const LIST_AWBALLOTMENTS_URL = "api/admin/list-awballotments";
  const [loading, setLoading] = useState(true);
  const [Franchiseloading, setFranchiseloading] = useState(false);
  const [error, setError] = useState(null); // To handle errors
  const [AwbAllotments, setAwbAllotments] = useState([]);


  // const fetchAwbAllotments = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axiosPrivate.get(LIST_AWBALLOTMENTS_URL, {});
  //     setAwbAllotments(response.data);
  //     setError(null);
  //   } catch (error) {
  //     console.error("Error fetching Awb Allotmentss:", error);
  //     setError("Failed to load Awb Allotmentss");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchAwbAllotments();
  // }, []);


  const fetchAwbAllotments = async () => {
    setLoading(true);
    try {
      const response = await axiosPrivate.get(LIST_AWBALLOTMENTS_URL);

      console.log("FULL RESPONSE:", response);
      console.log("RESPONSE.DATA:", response.data);
      console.log("IS ARRAY?", Array.isArray(response.data));

      // setAwbAllotments(response.data);
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      setAwbAllotments(data);

      setError(null);
    } catch (error) {
      console.error("Error fetching Awb Allotments:", error);
      setError("Failed to load Awb Allotments");
      setAwbAllotments([]);
    } finally {
      setLoading(false);
    }
  };







  const [selectedFranchise, setSelectedFranchise] = useState(null);

  // Handle selection from dropdown
  const handleSelect = (franchise) => {
    setFranchiseName(franchise.franchise_name);
    setFranchiseDbId(franchise.franchise_id);
    setFranchiseCode(franchise.franchise_code)
    setSelectedFranchise(franchise);
    setFilteredFranchises([]);
  };

  const debounceRef = useRef(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setFranchiseName(value);

    // Clear dropdown if input is empty
    if (!value.trim()) {
      setFilteredFranchises([]);
      return;
    }

    // Debounce API call
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchFranchises(value);
    }, 400);
  };


  const fetchFranchises = async (searchValue) => {
    try {
      setLoading(true);
      setFranchiseloading(true)
      const response = await axiosPrivate.get(
        `api/list-franchises`,
        {
          params: {
            // franchise_name: searchValue,
            // franchise_code: searchValue,
            search_text: searchValue
          },
        }
      );

      setFilteredFranchises(response.data || []);
    } catch (error) {
      console.error("Error fetching franchises", error);
      setFilteredFranchises([]);
    } finally {
      setLoading(false);
      setFranchiseloading(false)
    }
  };

  const showMessageTemporarily = (type, message, duration = 10000) => {
    if (type === "error") {
      setErrMsg(message);
      setSuccessMsg("");
    } else {
      setSuccessMsg(message);
      setErrMsg("");
    }

    setTimeout(() => {
      setErrMsg("");
      setSuccessMsg("");
    }, duration);
  };


  const postinAwbAllotment = async () => {
    try {
      const data = {
        awb_from: AwbFrom,
        awb_to: AwbTo,
        franchise_id: franchiseDbId,
      };

      await axiosPrivate.post(AWB_ALLOTMENT_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      // Clear form fields
      setFranchiseName("");
      setFranchiseDbId("");
      setAwbFrom("");
      setAwbTo("");

      // Show success message
      showMessageTemporarily("success", "AWB allotted successfully");

    } catch (err) {
      let message = "Something went wrong";

      if (!err?.response) {
        message = "No server response";
      } else if (err.response?.status === 409) {
        message = err.response?.data?.message;
      } else {
        message = err.response?.data?.message || "Submission failed";
      }

      showMessageTemporarily("error", message);
      errRef.current?.focus();
    }
  };






  const handleSubmit = async (e) => {
    e.preventDefault();
    // if button enabled with JS hack

    await postinAwbAllotment();
    await fetchAwbAllotments();
  };

  const navigate = useNavigate();
  const logout = useLogout();

  // const signOut = async () => {
  //     await logout();
  //     navigate('/login');
  // }

  const [franchiseName, setFranchiseName] = useState("");

  return (
    <>

      <section className="newsections">
        <p
          ref={errRef}


        >
          {errMsg && (
            <p ref={errRef} className="errmsg" aria-live="assertive">
              {errMsg}
            </p>
          )}

          {successMsg && (
            <p className="success" aria-live="polite">
              {successMsg}
            </p>
          )}

        </p>

        <div className=" newwrap">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

            <br /><h3>AWB Allotment</h3>


            <Row>

              <Col>
                <div className="input-boxs">
                  <label htmlFor="FranchiseName">
                    Franchise Name or Code <sup>*</sup>
                  </label>

                  <input
                    type="text"
                    id="franchise-name"
                    autoComplete="off"
                    placeholder="Search Franchise Name or Code"
                    onChange={handleInputChange}
                    value={franchiseName}
                    required
                    style={styles.input}
                  />

                  {Franchiseloading && <div className="loader" style={{ color: "black" }}>Searching...</div>}

                  {franchiseName && filteredFranchises.length > 0 && (
                    <ul style={styles.dropdown}>
                      {filteredFranchises.map((franchise) => (
                        <li
                          key={franchise.franchise_id}
                          style={styles.dropdownItem}
                          onMouseDown={() => handleSelect(franchise)}
                        >
                          {franchise.franchise_name} ({franchise.franchise_code})
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

              </Col>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="franchise-code">Franchise Code  </label>
                  <input
                    type="text"
                    id="franchise-code"
                    value={franchiseCode}
                    readOnly
                    autoComplete="off"
                    placeholder=""
                    style={styles.input}
                  />

                </div>
              </Col>
            </Row>
            <Row>

              <Col>

                <div className=" input-boxs">
                  <label htmlFor="Username">AWB From </label>
                  <input
                    type="text"
                    id="AwbFrom"
                    placeholder=""
                    onChange={(e) => setAwbFrom(e.target.value)}
                    value={AwbFrom}
                    required

                  />

                </div>
              </Col>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="Username">AWB To</label>
                  <input
                    type="text"
                    id="AwbTo"
                    autoComplete="off"
                    placeholder=""
                    onChange={(e) => setAwbTo(e.target.value)}
                    value={AwbTo}
                    required

                    aria-describedby="usernamenote"
                    onFocus={() => setUserFocus(true)}
                    onBlur={() => setUserFocus(false)}
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}

                </div>
              </Col>
            </Row>

            <center>
              <button type="submit" className="btn regbutton"> Submit</button>
            </center>
          </form>
          {/* </div>
        </section>        
   

        <section className="newsections">
        <div className="newwrap"> */}
          <table border="1" id="customers">
            <thead>
              <tr>
                <th>Franchise</th>
                <th>Allotment date</th>
                <th>AWB from</th>
                <th>AWB to</th>
                <th>Total</th>
                <th>Used</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(AwbAllotments) &&
                AwbAllotments.map((Allotments, index) => (

                  <tr key={index}>

                    <td>{Allotments.franchise_name} - {Allotments.franchise_code} </td>
                    <td>{Allotments.allotment_date}</td>
                    <td>{Allotments.awb_from}</td>
                    <td>{Allotments.awb_to}</td>
                    <td>{Allotments.total}</td>
                    <td>{Allotments.used}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
      <TopBar />
    </>
  );
};

const styles = {
  container: {
    padding: '40px',
    maxWidth: '500px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderTop: 'none',
    maxHeight: '200px',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
    color: '#000',          // force black
    backgroundColor: '#fff' // ensure contrast
  },
  button: {
    padding: '10px 15px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },


};

const messageStyles = {
  error: {
    color: "#fff",
    backgroundColor: "#dc3545",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "10px",
    textAlign: "center",
  },
  success: {
    color: "#fff",
    backgroundColor: "#28a745",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "10px",
    textAlign: "center",
  },
};


export default AwbAllotment;
